
import { RevButton } from '@ds/components/Button'
import { RevLink } from '@ds/components/Link'

import FormattedMessage from '@i18n/components/FormattedMessage'
import { ROUTES } from '@router'
import { trackClick } from '@tracking/events'

import { GOOGLE_URL } from './AboutUs.constants'
import translations from './AboutUs.translations'

export default {
  components: {
    RevButton,
    RevLink,
    FormattedMessage,
  },
  computed: {
    translations: () => translations,
    GOOGLE_URL: () => GOOGLE_URL,
    ctaRoute() {
      return { name: ROUTES.ABOUT_US }
    },
  },
  methods: {
    trackInteraction() {
      trackClick({ zone: 'detail', name: 'get_to_know_us' })
    },
  },
}
